import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import api from "../lib/api";
import { DashboardShell } from "../components/shared/DashboardShell";
import { studentNav, companyNav, adminNav } from "../components/shared/navConfig";
import { useAuth } from "../context/AppContext";

const fmt = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

export default function NotificationsPage() {
  const { role } = useAuth();
  const nav = role === "company" ? companyNav : role === "admin" ? adminNav : studentNav;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/notifications/mine"); setItems(data.items || []); }
      catch {} finally { setLoading(false); }
    })();
  }, []);

  return (
    <DashboardShell nav={nav} title="Notifications" subtitle="Everything that happened on your account">
      <div className="card-surface p-5">
        {loading ? <div className="text-sm text-zinc-500">Loading…</div> :
          items.length === 0 ? (
            <div className="py-12 text-center text-sm text-zinc-500">
              <Bell size={22} className="mx-auto mb-3 text-zinc-600"/>You have no notifications yet.
            </div>
          ) : (
            <div className="space-y-2">
              {items.map(n => (
                <div key={n.notification_id} className="p-4 rounded-md border flex gap-3" style={{ borderColor: "var(--border)", background: "var(--surface)" }}>
                  <div className="w-1 rounded-full self-stretch" style={{ background: n.read ? "transparent" : "#3B82F6" }}/>
                  <div>
                    <div className="text-sm text-white">{n.title}</div>
                    {n.body && <div className="text-xs text-zinc-500 mt-1">{n.body}</div>}
                    <div className="text-[10px] font-mono text-zinc-500 mt-1">{fmt(n.created_at)}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>
    </DashboardShell>
  );
}
